import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from '../../Helpers/TokenHelper'
import store from '../../store'
import { barcodesSectionId, movementSectionId, quantitySectionId } from '../../Constants/Configuration'

export interface ISize {
  sizeName: string
  sizeId: number
  sizeOrder: number
}

export interface IBarcode {
  value: string
  variant: number
  size: ISize
  isPublic: boolean
}
export interface IBarcodeAndSizes {
  barcodes: IBarcode[]
  sizes: ISize[]
}

export interface IBarcodeWithExtraProps extends IBarcode {
  isDeleted: boolean
  originalValue: string
}

export function getBarcode(barcode) {
  const state = store.getState()
  const token = getTokenFromSessionStorage()

  if (!state.present.article.serverConfig || !token) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  return createRequest(
    '/api/barcodes/' + barcode + '/?config=' + state.present.article.serverConfig,
    'GET',
    undefined,
    token,
  )
    .then(response => response.json())
    .catch(err => {
      handleErrorCatchLog(err, 'Failed to get Barcode')
    })
}

export function getBarcodesAndSizes(articleId): Promise<IBarcodeAndSizes | {}> {
  const state = store.getState()
  const gridEnable: boolean =
    state.present.dynamicGrid.gridLayout.findIndex(gridElement => gridElement.i === barcodesSectionId) >= 0
  const token = getTokenFromSessionStorage()

  if (
    !state.present.article.serverConfig ||
    state.present.article.rowKeysSelected[0] !== articleId ||
    !gridEnable ||
    !token
  ) {
    return new Promise(resolve => {
      resolve({})
    })
  }

  const url = `/api/barcodes/byArticle/${articleId}?config=${state.present.article.serverConfig}`
  return createRequest(url, 'GET', null, token, true, true)
    .then(response => response.json())
    .catch(err => {
      handleErrorCatchLog(err, 'Failed to get Barcodes And Sizes')
    })
}

export function deleteBarcodes(barcodes: string[]) {
  return (dispatch, getState) => {
    const state = getState()
    const token = getTokenFromSessionStorage()
    if (!state.present.article.serverConfig || !token) {
      return new Promise(resolve => {
        resolve([])
      })
    }

    const url = `/api/barcodes/delete?config=${state.present.article.serverConfig}`
    return createRequest(url, 'POST', barcodes, token, true, true)
      .then(response => response.json())
      .catch(err => {
        handleErrorCatchLog(err, 'Failed to delete barcodes')
      })
  }
}

export interface UpdatePublicBarcodesRequest {
  barcodes: UpdatePublicBarcodeRequest[]
}

export interface UpdatePublicBarcodeRequest {
  oldValue: string
  newValue: string
}

export function updatePublicBarcodes(request: UpdatePublicBarcodesRequest) {
  return (dispatch, getState) => {
    const state = getState()
    const token = getTokenFromSessionStorage()
    if (!state.present.article.serverConfig || !token) {
      return new Promise(resolve => {
        resolve([])
      })
    }

    const url = `/api/barcodes/update?config=${state.present.article.serverConfig}`
    return createRequest(url, 'POST', request, token, true, true)
      .then(response => response.json())
      .catch(err => {
        handleErrorCatchLog(err, 'Failed to update barcodes')
      })
  }
}

export interface InsertPublicBarcodeRequest {
  barcodesAndSizeIds: BarcodeAndSizeId[]
}

export interface BarcodeAndSizeId {
  barcode: string
  sizeId: number
}

export function insertPublicBarcodes(articleId: number, request: InsertPublicBarcodeRequest) {
  return (dispatch, getState) => {
    const state = getState()
    const token = getTokenFromSessionStorage()
    if (!state.present.article.serverConfig || !token) {
      return new Promise(resolve => {
        resolve([])
      })
    }

    const url = `/api/barcodes/insert/${articleId}?config=${state.present.article.serverConfig}`
    return createRequest(url, 'POST', request, token, true, true)
      .then(response => response.json())
      .catch(err => {
        handleErrorCatchLog(err, 'Failed to insert barcodes')
      })
  }
}
